(function ($) {
    function getInt($element, attribute, fallback) {
        var value = parseInt($element.attr(attribute), 10);

        return Number.isNaN(value) ? fallback : value;
    }

    function getBool($element, attribute) {
        return $element.attr(attribute) === '1';
    }

    function getSlideBy($element) {
        return $element.attr('data-slide-by') === 'page' ? 'page' : 1;
    }

    function getNavText() {
        return [
            "<span class='sr-only'>Previous slide</span><i class='icon-angle-left' aria-hidden='true'></i>",
            "<span class='sr-only'>Next slide</span><i class='icon-angle-right' aria-hidden='true'></i>",
        ];
    }

    function cleanDuplicateControls($carousel) {
        $carousel.children('.owl-nav').not(':first').remove();
        $carousel.children('.owl-dots').not(':first').remove();
    }

    function syncCarouselWidth($carousel) {
        var $parent = $carousel.parent();
        var parentWidth = Math.floor($parent.innerWidth());

        if (parentWidth > 0) {
            $carousel.css('width', parentWidth + 'px');
        }
    }

    function refreshCarousel($carousel) {
        syncCarouselWidth($carousel);
        $carousel.trigger('refresh.owl.carousel');
        cleanDuplicateControls($carousel);
    }

    function initCarousel(selector, defaults) {
        if (!$.fn.owlCarousel) {
            return;
        }

        $(selector).each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                return;
            }

            var desktopItems = getInt($carousel, 'data-items-desktop', defaults.desktopItems);
            var tabletItems = getInt($carousel, 'data-items-tablet', defaults.tabletItems);
            var mobileItems = getInt($carousel, 'data-items-mobile', defaults.mobileItems);
            var itemCount = getInt($carousel, defaults.countAttribute, 0);
            var hasMultiplePages = itemCount > desktopItems;
            var gap = getInt($carousel, 'data-gap', defaults.gap);
            var arrows = getBool($carousel, 'data-arrows');
            var dots = getBool($carousel, 'data-dots');
            var loop = getBool($carousel, 'data-loop') && hasMultiplePages;
            var autoplay = getBool($carousel, 'data-autoplay') && hasMultiplePages;
            var autoplayDelay = getInt($carousel, 'data-autoplay-delay', 4500);

            syncCarouselWidth($carousel);

            $carousel.owlCarousel({
                margin: gap,
                items: desktopItems,
                slideBy: getSlideBy($carousel),
                loop: loop,
                autoplay: autoplay,
                autoplayTimeout: autoplayDelay,
                autoplayHoverPause: true,
                smartSpeed: 500,
                nav: arrows && hasMultiplePages,
                dots: dots && hasMultiplePages,
                navText: getNavText(),
                responsive: {
                    0: { items: mobileItems },
                    768: { items: tabletItems },
                    1200: { items: desktopItems },
                },
            });

            $carousel.data('ddOwlCarousel', true);
            cleanDuplicateControls($carousel);

            window.requestAnimationFrame(function () {
                refreshCarousel($carousel);
            });
        });
    }

    function initSingleSlideCarousel(selector) {
        if (!$.fn.owlCarousel) {
            return;
        }

        $(selector).each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                return;
            }

            var slideCount = getInt($carousel, 'data-slide-count', 0);
            var hasMultipleSlides = slideCount > 1;
            var arrows = getBool($carousel, 'data-arrows');
            var dots = getBool($carousel, 'data-dots');
            var loop = getBool($carousel, 'data-loop') && hasMultipleSlides;
            var autoplay = getBool($carousel, 'data-autoplay') && hasMultipleSlides;
            var autoplayDelay = getInt($carousel, 'data-autoplay-delay', 4500);

            syncCarouselWidth($carousel);

            $carousel.owlCarousel({
                items: 1,
                margin: 0,
                loop: loop,
                autoplay: autoplay,
                autoplayTimeout: autoplayDelay,
                autoplayHoverPause: true,
                smartSpeed: 500,
                nav: arrows && hasMultipleSlides,
                dots: dots && hasMultipleSlides,
                navText: getNavText(),
            });

            $carousel.data('ddOwlCarousel', true);
            cleanDuplicateControls($carousel);

            window.requestAnimationFrame(function () {
                refreshCarousel($carousel);
            });
        });
    }

    function initTestimonialsCarousel() {
        if (!$.fn.owlCarousel) {
            return;
        }

        $('.testimonials-slider.owl-carousel').each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                return;
            }

            var itemCount = getInt($carousel, 'data-testimonial-count', 0);

            if (!itemCount) {
                return;
            }

            syncCarouselWidth($carousel);

            $carousel.owlCarousel({
                items: 2,
                margin: 16,
                slideBy: 1,
				loop: itemCount > 1,
				rewind: false,
				autoplay: itemCount > 1,
				autoplayTimeout: 4500,
				autoplayHoverPause: true,
                smartSpeed: 500,
                nav: false,
                dots: false,
                mouseDrag: itemCount > 1,
                touchDrag: itemCount > 1,
                responsive: {
                    0: { items: 1 },
                    768: { items: 2 },
                    1200: { items: 2 },
                },
            });

            $carousel.data('ddOwlCarousel', true);

            window.requestAnimationFrame(function () {
                refreshCarousel($carousel);
            });
        });
    }

    function initProjectTimelines() {
        if (!window.gsap || !window.ScrollTrigger) {
            return;
        }

        window.gsap.registerPlugin(window.ScrollTrigger);

        $('.project-timeline[data-timeline-animation="1"]').each(function () {
            var element = this;
            var $timeline = $(element);

            if ($timeline.data('ddGsapTimeline')) {
                return;
            }

            var items = element.querySelectorAll('.timeline-item');
            var remainingItems = Array.prototype.slice.call(items, 1);
            var progress = element.querySelector('.timeline-progress');
            var duration = parseFloat(element.getAttribute('data-timeline-duration')) || 0.55;
            var stagger = parseFloat(element.getAttribute('data-timeline-stagger')) || 0.22;

            if (!items.length || !progress) {
                return;
            }

            $timeline.data('ddGsapTimeline', true);

            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                return;
            }

            element.classList.add('is-gsap-ready');

            var matchMedia = window.gsap.matchMedia();

            function createTimeline(isMobile) {
				var initialProgress = items.length > 1 ? 1 / (items.length - 1) : 1;

				window.gsap.set(items[0], { opacity: 1, y: 0 });
				window.gsap.set(remainingItems, { opacity: 0.18, y: 14 });
                window.gsap.set(progress, isMobile
					? { scaleX: 1, scaleY: initialProgress, transformOrigin: 'center top' }
					: { scaleX: initialProgress, scaleY: 1, transformOrigin: 'left center' });

                var animation = window.gsap.timeline({
                    defaults: { ease: 'power2.out' },
                    scrollTrigger: {
                        trigger: element,
                        start: 'top 75%',
                        once: true,
                    },
                });

                animation.to(progress, {
                    scaleX: 1,
                    scaleY: 1,
                    duration: Math.max(duration, duration + (stagger * (items.length - 1))),
                    ease: 'none',
                }, 0);

				animation.to(remainingItems, {
                    opacity: 1,
                    y: 0,
                    duration: duration,
                    stagger: stagger,
                }, 0);

                return function () {
                    animation.kill();
                };
            }

            matchMedia.add('(min-width: 768px)', function () {
                return createTimeline(false);
            });

            matchMedia.add('(max-width: 767px)', function () {
                return createTimeline(true);
            });
        });
    }

    function initChallengeSolution() {
        $('[data-challenge-solution]').each(function () {
            var element = this;
            var $element = $(element);
            var range = element.querySelector('.challenge-solution-range');
            var states = element.querySelectorAll('[data-challenge-solution-state]');

            if (!range || $element.data('ddChallengeSolution')) {
                return;
            }

            function setState(value) {
                var isSolution = String(value) === '1';
                var activeState = isSolution ? 'solution' : 'challenge';
                var labelAttribute = isSolution ? 'data-solution-label' : 'data-challenge-label';

                element.setAttribute('data-active-state', activeState);
                element.style.setProperty('--challenge-solution-progress', isSolution ? '1' : '0');
                range.setAttribute('aria-valuetext', range.getAttribute(labelAttribute) || activeState);

                Array.prototype.forEach.call(states, function (state) {
                    var isActive = state.getAttribute('data-challenge-solution-state') === activeState;

                    state.classList.toggle('is-active', isActive);
                    state.setAttribute('aria-hidden', isActive ? 'false' : 'true');
                });
            }

            range.addEventListener('input', function () {
                setState(range.value);
            });

            range.addEventListener('change', function () {
                setState(range.value);
            });

            setState(range.value);
            $element.data('ddChallengeSolution', true);
        });
    }

    function refreshCarousels() {
        $('.gallery-slider.owl-carousel, .block-cpt-slider.owl-carousel, .taxonomy-posts-slider.owl-carousel, .logos-slider.owl-carousel, .grid-card-slider.owl-carousel, .text-image-slider.owl-carousel, .testimonials-slider.owl-carousel').each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                refreshCarousel($carousel);
            }
        });
    }

    function debounce(callback, delay) {
        var timer = null;

        return function () {
            window.clearTimeout(timer);
            timer = window.setTimeout(callback, delay);
        };
    }

    function initLightboxes() {
        if (!$.fn.lightGallery) {
            return;
        }

        $('.gallery-lightbox').each(function () {
            var $gallery = $(this);

            if ($gallery.data('ddLightGallery')) {
                return;
            }

            $gallery.lightGallery({
                selector: '.gallery-lightbox-item',
                share: true,
                download: true,
                rotate: false,
                showThumbByDefault: true,
                loop: false,
                thumbnail: true,
                allowMediaOverlap: true,
                toggleThumb: true,
            });

            $gallery.data('ddLightGallery', true);
        });
    }

    $(function () {
        initLightboxes();

        initCarousel('.gallery-slider.owl-carousel', {
            countAttribute: 'data-image-count',
            desktopItems: 1,
            tabletItems: 1,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.block-cpt-slider.owl-carousel', {
            countAttribute: 'data-post-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.taxonomy-posts-slider.owl-carousel', {
            countAttribute: 'data-post-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.logos-slider.owl-carousel', {
            countAttribute: 'data-logo-count',
            desktopItems: 4,
            tabletItems: 3,
            mobileItems: 2,
            gap: 24,
        });

        initCarousel('.grid-card-slider.owl-carousel', {
            countAttribute: 'data-card-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initSingleSlideCarousel('.text-image-slider.owl-carousel');
        initTestimonialsCarousel();
        initProjectTimelines();
        initChallengeSolution();

		document.dispatchEvent(new CustomEvent('dd:blocks:ready'));

        $(window).on('load', refreshCarousels);
        $(window).on('resize orientationchange', debounce(refreshCarousels, 150));
    });
})(jQuery);
